module.exports = __webpack_public_path__ + "static/media/1.bcf1aa3d.jpg";